import React from 'react';
import LogoGroup from 'img/header-mafra-group.svg';
import LogoCCare from 'img/customer-care-header-logo.svg';

import { Container } from './styles';

const SoftHeader: React.FC = () => {
  return (
    <Container>
      <header className={`px-sm-2 p-3 relative z-6`}>
        <div className="header-logo-box-page-out">
          <img
            width="220"
            className="mr-3"
            src={LogoGroup}
            alt="logo viveo"
          />
          <img
            width="200"
            src={LogoCCare}
            alt="logo ccare"
          />
        </div>
      </header>
    </Container>
  );
};

export default SoftHeader;